module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-4-9c94daabc9d8ce61073e6a599dabf610.jpg";